import { render, staticRenderFns } from "./AwsOrder.vue?vue&type=template&id=51fa9d1a&scoped=true&"
import script from "./AwsOrder.vue?vue&type=script&lang=js&"
export * from "./AwsOrder.vue?vue&type=script&lang=js&"
import style0 from "./AwsOrder.vue?vue&type=style&index=0&id=51fa9d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fa9d1a",
  null
  
)

export default component.exports